// Generated by Claude Code
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function NotFoundPage() {
  const { t } = useTranslation('home')
  return (
    <div className="ynt-fullscreen-center flex-column text-center gap-2 px-3">
      <h1 className="h4 fw-bold mb-0">{t('notFound.title')}</h1>
      <p className="text-muted mb-2">{t('notFound.body')}</p>
      <Link to="/" className="btn btn-primary">{t('notFound.home')}</Link>
    </div>
  )
}
